import React from 'react';
import _ from 'lodash';
import Logger from '../../util/Logger';
import './Dropdown.css';

export default class Dropdown extends React.Component {

  constructor (props) {
    super(props);

    const { id, text, itemList, onSelected } = this.props;
    if (!id) {
      Logger.assert('Cannot create Dropdown without id');
    }
    if (!text) {
      Logger.assert('Cannot create Dropdown without text');
    }
    if (!itemList) {
      Logger.assert('Cannot create Dropdown without itemList');
    }
    if (!onSelected) {
      Logger.assert('Cannot create Dropdown without onSelected callback');
    }

    if (itemList.length === 0) {
      Logger.assert(`Cannot create Dropdown with empty itemList`);
    }

    _.forEach(itemList, (item, i) => {
      if (!item) {
        Logger.assert(`Cannot create Dropdown without valid item in itemList: ${i}`);
      }

      if (!item.id) {
        Logger.assert(`Cannot create Dropdown: item missing id: ${i}`);
      }

      if (!item.text) {
        Logger.assert(`Cannot create Dropdown: item missing text: ${i}`);
      }
    });
  }

  render () {
    const { id, text, itemList, onSelected, disabled } = this.props;
    return (
      <div className="dropdown d-inline-block">
        <div
          id={ id }
          className="row open-dropdown no-gutters"
          data-toggle={ `${disabled ? '' : 'dropdown'}` }
          aria-haspopup="true"
          aria-expanded="false">

          <div className={ `text-section ${disabled ? '' : 'clickable'}` }>
            <span
              className={ `${disabled ? 'dropdown-disabled' : 'dropdown-enabled'}` }><b>{ text }</b>
            </span>
            <i
              className={ `material-icons ${disabled ? 'dropdown-disabled' : 'dropdown-enabled'}` }>
              arrow_drop_down
            </i>
          </div>

        </div>

        <div className="dropdown-menu" aria-labelledby={ id }>
          {
            _.map(itemList, (item) =>
              <div
                className="dropdown-item clickable"
                id={ item.id }
                key={ item.id }
                onClick={ () => onSelected(item) }>
                { item.text }
              </div>
            )
          }
        </div>
      </div>
    );
  }
}
